import React, { useState, useEffect } from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer/Footer';
import '../../styles/IQAC-Committee.css';

const committeeMembers = [
  {
    name: 'Prof. A. S. Patekar',
    role: 'IQAC Chairperson',
    details: 'Head of institution, oversees the quality assurance process across departments and administration.'
  },
  {
    name: 'Dr. Sahadeo Aher',
    role: 'NAAC Coordinator',
    details: 'Coordinates NAAC documentation and ensures compliance with standards.'
  },
  {
    name: 'Prof. B. D. Nawale',
    role: 'Administrative Member',
    details: 'Handles admin quality metrics, process improvements, and support functions.'
  },
  {
    name: 'Prof. C. S. Patil',
    role: 'Faculty Member',
    details: 'Contributes to academic planning and internal audit of teaching-learning process.'
  },
  // Add more as needed
];

const IQACCommittee = () => {
  const [fade, setFade] = useState(false);
  const [selectedMember, setSelectedMember] = useState(null);

  useEffect(() => {
    window.scrollTo(0, 0);
    setTimeout(() => setFade(true), 100);
  }, []);

  const openModal = (member) => setSelectedMember(member);
  const closeModal = () => setSelectedMember(null);

  return (
    <>
      <Navbar />
      <section className='section-wrapper-no-text-align'>
      <div className={`iqac-container ${fade ? 'fade-in' : ''}`}>
        <section className="iqac-header">
          <h4>Shri Mulikadevi Mahavidyalaya, Nighoj</h4>
          <h2>IQAC Committee</h2>
          <p>
            The Internal Quality Assurance Cell (IQAC) aims to maintain and enhance the academic and administrative quality of the college.
          </p>
        </section>

        <section className="committee-section">
          {committeeMembers.map((member, i) => (
            <div key={i} className="committee-card animate-card">
              <p className="member-name">{member.name}</p>
              <p className="member-role">{member.role}</p>
              <button onClick={() => openModal(member)} className="learn-more-btn">Learn More</button>
            </div>
          ))}
        </section>
      </div>

      {selectedMember && (
        <div className="modal-overlay" onClick={closeModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <h3>{selectedMember.name}</h3>
            <h5>{selectedMember.role}</h5>
            <p>{selectedMember.details}</p>
            <button className="close-btn" onClick={closeModal}>Close</button>
          </div>
        </div>
      )}
      </section>
      <Footer />
    </>
  );
};

export default IQACCommittee;
